module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("8tYz2"))).then(() => parcelRequire('iPJbm'));